import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Gallery from './components/Gallery/Gallery';
import Video from './components/Video/Video';
import Virtualtour from './components/VirtualTour/VirtualTour';
import Map from './components/Map/Map';
import Contact from './components/ContactUs/Contact';
function App() {
  return (
    <>
        <Header/>
        <main className='main'>
          <Home/>
          <Gallery/>
          <Video/>
          <Virtualtour/>
          <Map/>
          <Contact/>
        </main>
    </>
  );
}

export default App;
